import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!isSupabaseConfigured) {
    throw new Error(
      "Supabase não configurado. Define VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY.",
    );
  }
  if (!client) {
    client = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}

export const supabase = isSupabaseConfigured ? getSupabase() : null;

export function formatAuthError(message: string): string {
  if (message.includes("Invalid login credentials")) {
    return "Email ou password incorretos.";
  }
  if (message.includes("Email not confirmed")) {
    return "Confirma o email antes de entrar.";
  }
  if (message.includes("Password should be at least")) {
    return "A password deve ter pelo menos 6 caracteres.";
  }
  return message;
}
